/* jshint -W072 */ // TO DO: fix maxparams violation?
angular.module('core')
    .controller('MasterController', [
        '$scope',
        '$state',
        '$rootScope',
        '$location',
        'assignMode',
        'navigationApi',
        'mediaQuery',
        '$timeout',
        '$window',
        '$modal',
        'configuration',
        'cancelableResourceManager',
        'classroomApi',
        'timeframe',
        '$cacheFactory',
        'moment',
        'authentication',
        '$analytics',
        'dblAnalyticsProvider',
        'dblAnalyticsPluginProvider',
        'dblDebugProvider',
        'dblLessonService',
        'dblProductResourcesService',
        'dblUserAgent',
        'edxPendingChangesModalService',
        'edxReportItemService',
        'edxCustomerSettingsService',
        'navigation',
        'studentApi',
        '$cachedResource',
        'edxUxPreferenceService',
        'edxPreviewBannerService',
        '$log',
        function (
            $scope,
            $state,
            $rootScope,
            $location,
            // assignMode isn't used directly by this controller, but loading it here registers event handlers
            // needed when the browser is refreshed while creating an assignment.
            assignMode,
            $navigationApi,
            $mediaQuery,
            $timeout,
            $window,
            $modal,
            $configuration,
            $cancelableResourceManager,
            classroomApi,
            timeframe,
            $cacheFactory,
            $moment,
            authentication,
            $analytics,
            dblAnalytics,
            dblAnalyticsPlugin,
            dblDebug,
            dblLessonService,
            dblProductResourcesService,
            dblUserAgent,
            edxPendingChangesModalService,
            edxReportItemService,
            edxCustomerSettingsService,
            navigation,
            studentApi,
            $cachedResource,
            uxPreferenceService,
            edxPreviewBannerService,
            $log) {
            /* jshint +W072 */

            $scope.item = null;
            $scope.itemList = [];
            var _classroomList;
            var _itemList;
            var _teacherItem;

            $rootScope.mobile = ((/(iPad|iPhone|iPod|Android|IEMobile|BB10)/gi).test($window.navigator.userAgent));
            $rootScope.perfectScrollbarSpeed = $rootScope.mobile ? 10 : 3;

            var perfectScrollbarSelector = '.scroll-bar';
            var isLoggingOut = false;
            var valuesToKeepInStorage = ['ast', 'ast_code'];

            $scope.init = function (productApiUrl, build_time, clear_cache, contentRoot, config) {
                $scope.productApiUrl = productApiUrl; //deprecated
                $rootScope.productApiUrl = productApiUrl; // deprecated; use dblProductResourcesService
                dblProductResourcesService.init(productApiUrl, contentRoot);
                $rootScope.build_time = build_time ? build_time : undefined;
                $configuration.init(config);
                $rootScope.currentSchoolYear = timeframe.calculateCurrentReportingYear();
                dblLessonService.setLessonRootUrl(productApiUrl);

                $scope.hideFTUE = $configuration.isTrue('application.FTUE.hide');

                // clear browser cache on login
                if (clear_cache === "true") {
                  var cacheSavedValues = {};
                  // save ast storage values
                  valuesToKeepInStorage.forEach(function(cacheKeyToKeep) {
                    var storeValue = window.sessionStorage.getItem(cacheKeyToKeep);
                    if(storeValue) {
                      cacheSavedValues[cacheKeyToKeep] = storeValue;
                    }
                  });

                    $scope.clearStorage();

                  // add saved ast storage values
                  valuesToKeepInStorage.forEach(function(cacheKeyToKeep) {
                    if(cacheSavedValues[cacheKeyToKeep])
                    {
                      window.sessionStorage.setItem(cacheKeyToKeep, cacheSavedValues[cacheKeyToKeep]);
                    }
                  });

                }
                // todo note: we should move the configuration service initialization out of main controller init() to to a more appropriate upstream location in the app lifecycle

                // Please note: dbl-analytics provider must be the first to handle the event since ga_analytics sets the value fields as 0, which is not expected.
                if ($configuration.isFeatureEnabled('dbl_analytics_enabled')) {
                    var dblOptions = {
                        providerName: 'dbl-analytics',
                        categoryExceptionsList: $configuration.getAnalyticsCategoryExceptions('dblProvider')
                    };
                    dblAnalytics.addProvider(dblAnalyticsPlugin, dblOptions);
                }

                // capturing route change events
                // TODO: We use ui-router, not AngularJS routing, so this doesn't appear to do anything
                $rootScope.$on('$routeChangeSuccess', function (event, current) {
                    if (current && (current.$$route || current).redirectTo) {
                        return;
                    }
                    dblAnalytics.pageTrack($location.url(), $location);
                });

                // start capturing state change events - stateChangeStart established the start time for a stateRoute "pane" which equals a Tab on the dashboard
                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    // "to" params are passed in here to start the tracking of the next state.
                    // The navigation service should be remembering the previous state.
                    navigation.routeStateFinish(toState.name, toParams);
                });

                //capture state success - This equals a virtual page view
                $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    // why trigger pageTrack analytics on both start start and state success?
                    // does this send a second page view event to google analytics?
                    navigation.routeStateStart(toState.name, toParams);
                });

                //capture ping Keepalive broadcast and send session event
                $rootScope.$on('Keepalive', function (event, data) {
                    dblAnalytics.eventTrack(dblAnalytics.settings.knownEventActions.PING, {
                        category: dblAnalytics.settings.knownEventCategories.SESSION
                    });
                });

                if ($configuration.isFeatureEnabled('debug_enabled')) {
                    //activate debugging service
                    dblDebug.activateDebugging();
                }
            };

            $scope.clearStorage = function () {
                $cachedResource.clearCache();
                sessionStorage.clear();
            };

            var checkEarlierYearSelected = function (e, selectedTimeFrame) {
                var oldValue = $rootScope.isEarlierYearSelected;
                $rootScope.isEarlierYearSelected = false;
                var timeframeValue = (selectedTimeFrame ? selectedTimeFrame.id : $state.params.timeframe);

                if (timeframeValue) {
                    var match, selectedYear;

                    // first check for school year selected, e.g. "2014y"
                    match = timeframeValue.match(/^(\d{4})y$/);
                    if (match) {
                        selectedYear = parseInt(match[1]);
                    } else {
                        // if no match, check for custom date range, e.g. "fd20140801td20150409"
                        match = timeframeValue.match(/^fd(\d{8})td\d{8}$/);
                        if (match) {
                            var fd = $moment(match[1], "YYYYMMDD");
                            selectedYear = timeframe.calculateReportingYear(fd);
                        }
                    }

                    if (selectedYear && selectedYear < $rootScope.currentSchoolYear) {
                        $rootScope.isEarlierYearSelected = true;
                    }
                }

                if (oldValue !== $rootScope.isEarlierYearSelected) {
                    $rootScope.$broadcast('earlierYearSelectionChange', $rootScope.isEarlierYearSelected);
                }

                if (
                  $state.params.pane === 'overview' &&
                  $state.current.name === 'classroom' &&
                  uxPreferenceService.isLoaded() &&
                  uxPreferenceService.getPreference(uxPreferenceService.registeredPreferences.classroomOverviewSimplified.key, '') === uxPreferenceService.registeredPreferences.classroomOverviewSimplified.treatments.simplified) {
                  // This is a hack to track use of timeframe dropdown on the simplified classroom overview
                  // Hopefully this can go away once the classic classroom overview is removed or the timeframe dropdown
                  // is improved
                  dblAnalytics.eventTrack('Select Timeframes - Grade View', {
                    category: 'Resource Used',
                    label: timeframeValue
                  });
                } else {
                  dblAnalytics.eventTrack('Select Timeframes', {
                    category: 'Resource Used',
                    label: timeframeValue
                  });
                }

            };

            $rootScope.$on('timeframeSelected', checkEarlierYearSelected);

            if ($state.current.name !== 'guardian') {
                // Used to control ng-class to animate show/hide of navigation pane
                $scope.showNavPane = ($scope._width > $mediaQuery.desktopWidth);
                // Used to control ng-class to show intial show/hide page state without animations.
                $scope.initialNavPane = $scope.showNavPane;
            } else {
                $scope.initialNavPane = false;
                $scope.showNavPane = false;
            }

            /* Watch the screen width - show and hide the navigation pane
             * depending on the current width;
             */
            $scope.$watch('_width', function (newWidth, oldWidth) {
                if (newWidth && oldWidth && newWidth !== oldWidth) {
                    if ($state.current.name !== 'guardian') {
                        $scope.initialNavPane = false;
                        $scope.showNavPane = (newWidth > $mediaQuery.desktopWidth);
                    } else {
                        $scope.showNavPane = false;
                        $scope.initialNavPane = false;
                    }
                }
            });

            $scope.$on('modalClose', function () {
                $scope.modal.close();
            });

            $scope.$on("standardChooserModal", function (e) {

                $scope.modal = $modal.open({
                    templateUrl: 'resources/core/partials/choose-standard-modal.html',
                    windowClass: 'common-modal',
                    controller: 'ChooseStandardModalController',
                    backdrop: 'static',
                    keyboard: true
                });
            });

            $scope.$on("familyInvitationLettersModal", function (e) {
                $scope.modal = $modal.open({
                    templateUrl: 'resources/core/partials/family-invitation-letters-modal.html',
                    windowClass: 'common-modal',
                    controller: 'FamilyInvitationLettersModalController',
                    backdrop: false,
                    keyboard: true,
                    resolve: {
                        item: function () {
                            return $scope.item;
                        }
                    }
                });
            });

            $scope.$on("chooseSchoolModal", function (e) {
                $scope.modal = $modal.open({
                    templateUrl: 'resources/core/partials/choose-school-modal.html',
                    windowClass: 'common-modal',
                    controller: 'ChooseSchoolModalController',
                    backdrop: 'static',
                    keyboard: true,
                    resolve: {
                        teacher: function () {
                            return authentication.getCustomer();
                        }
                    }
                });
            });

            $scope.$on("login", function (e) {
                trackSessionEvent("login");
            });

            $scope.$on("idleReset", function (e) {
                trackSessionEvent("idleReset");
            });

            $scope.$on("sessionExpired", function (e, args) {
                trackSessionEvent("sessionExpired", (args && args.abandonedByUser === true) ? 'session abandoned by user' : 'session expired by its own');

                $timeout(function () {
                    // expired session don't need dirty check confirmation to logout
                    // add some delay to allow above trackSessionEvent to finish. This is a simple solution that seems work. But to pursue a reliable tracking we'll need to wait
                    // trackSessionEvent to finish.
                    logout("/logout/expired", false);
                }, 500);
            });

            // Customer's password has been revoked (customer needs to set a new password)
            $scope.$on("sessionRevoked", function (e, args) {
                trackSessionEvent("sessionRevoked");

                $timeout(function () {
                  // expired session don't need dirty check confirmation to logout
                  // add some delay to allow above trackSessionEvent to finish. This is a simple solution that seems work. But to pursue a reliable tracking we'll need to wait
                  // trackSessionEvent to finish.
                  logout("/logout/revoked", false);
                }, 500);
            });

            // Customer's password has been reset (customer needs to re-authenticate)
            $scope.$on("passwordReset", function (e) {
                trackSessionEvent("passwordReset");

                // Add delay to give trackSessionEvent time to finish
                $timeout(function () {
                    // passwordReset don't need dirty check confirmation to logout
                    logout("/logout/no_auth", false);
                }, 500);
            });

            $scope.$on("sessionNoAuth", function (e) {
                trackSessionEvent("sessionNoAuth");

                // unauthorized don't need dirty check confirmation to logout
                logout("/logout/no_auth", false);
            });

            $scope.$on("logOutPressed", function (e) {
                window.logOutPressed = true;
                var loggingOut = function () {
                    trackSessionEvent("logOutPressed");

                    // add some delay to allow above trackSessionEvent to finish. This is a simple solution that seems work. But to pursue a reliable tracking we'll need to wait
                    // trackSessionEvent to finish.
                    $timeout(function () {
                        logout("/logout", true);
                    }, 500);
                };

                var saveButton = document.querySelector('.dbl-save-button');
                if (!saveButton) {
                    loggingOut();
                }
                var dirtyTab = !saveButton.firstChild.disabled;
                if (dirtyTab) {
                    edxPendingChangesModalService.setIsPending(true);
                    navigation.tryNavigate().then(function () {
                    $timeout(function () {
                        loggingOut();
                    }, 500);
                  });
                } else {
                    edxPendingChangesModalService.setIsPending(false);
                    loggingOut();
                }
            });

            var logout = function (path, dirtyCheck) {
                if (!isLoggingOut) {

                    var doLogout = function () {
                        path = path || "/logout";
                        $scope.clearStorage();

                        if ($scope.productApiUrl) {
                            isLoggingOut = true;
                            $window.location.href = path;
                        }
                    };

                    if (dirtyCheck && edxPendingChangesModalService.isPending()) {
                        edxPendingChangesModalService.open().then(function () {
                            doLogout();
                        });
                    } else {
                        doLogout();
                    }

                }
            };

            // On click on the menu show / hide navigation pane as necessary
            $scope.$on('onNavToggle', function (e) {
                $scope.initialNavPane = false;
                $scope.showNavPane = !$scope.showNavPane;
            });

            $rootScope.$on("userClosedNotificationSet", function (e) {
                sessionStorage.setItem('userClosedNotification', 'true');
                $scope.showPreviewBanner = false;
            });

            $scope.getItem = function () {
                var type = $state.current.name;
                var params = $state.params;

                // Create an rxjs subject for the current item.  This has to be done
                // before any components that might want to subscribe render.  Creating a new
                // subject for every reporting item ensures previous items aren't picked
                // up if a component renders before navigationApi.getItem returns.
                edxReportItemService.setCurrentItemSubject(new Rx.ReplaySubject(1));

                $navigationApi.getItem(type, params, function (item) {
                    if (item) {
                        // If there is no scope item - set it. Only update items if they are different objects
                        if (!$scope.item || ($scope.item && $scope.item !== item)) {
                            //TODO: Remove this. Should be handled by left pane controllers
                            $scope.item = item;
                        }

                        // This timeout causes the item notifications to happen in a later digest cycle which seems to
                        // allow the state change from which getItem is called to completely finish before
                        // potentially triggering another state change (as is frequently done to updated default
                        // timeframe and table sort).  This at least solves one issue where the main content area doesn't
                        // load when accessed by clicking top level breadcrumb.
                        //
                        // Ideally data requests would be initiated more directly from controllers instead of as
                        // a side effect of the $stateChangeSuccess handler.
                        $timeout(function () {
                            $log.debug('getItem - Broadcasting item');
                            edxReportItemService.setItem(item);

                            // deprecated: use edxReportItemService instead of itemReady event
                            $scope.$broadcast('itemReady', $scope.item);
                        }, 1000);
                    }
                });
            };

            var buildTeacherClassroomsName = function (teacherName) {
                return teacherName + '\'s Classrooms';
            };

            // update $scope.itemList if we've gathered enough info locally to build it
            var exposeItemList = function (customerIsAdmin) {
                if (_itemList) {
                    $scope.itemList = _itemList;
                }
            };

            // update $scope.classroomList if we've gathered enough info locally to build it
            var exposeClassroomList = function (customerIsAdmin) {
                if (_classroomList && _teacherItem) {
                    $scope.classroomList = _.sortBy(_.clone(_classroomList), 'name');

                    if (customerIsAdmin || _classroomList.length > 1) {
                        var teacherItem = _.clone(_teacherItem);
                        teacherItem.name = buildTeacherClassroomsName(teacherItem.name);
                        $scope.classroomList.unshift(teacherItem);
                    }
                }
            };

            $scope.getCurrentItemList = function () {
                var type = $state.current.name;
                var params = $state.params;
                _itemList = null;

                // For teacher customer construct an object to add to the classroom list
                // since we don't have a breadcrumb item to use.
                var customer = authentication.getCustomer();
                var customerIsTeacher = authentication.isTeacher(customer);
                var customerIsAdmin = authentication.isAdmin(customer);
                if (customerIsTeacher) {
                    _teacherItem = {
                        id: customer.id,
                        name: customer.name,
                        type: 'teacher'
                    };
                }

                $navigationApi.getList(type, params, customerIsAdmin, function (itemList) {
                    _itemList = itemList;
                    exposeItemList(customerIsAdmin);

                    if (itemList && itemList[0]) {
                        // If the list is classrooms, store it separately so
                        // we don't have to refetch if we go down to student level
                        if (itemList[0].type === 'classroom') {
                            _classroomList = itemList;
                            exposeClassroomList(customerIsAdmin);
                        }
                    }
                });

                if (type === 'student' || type === 'classroom' || type === 'teacher') {
                    // At student, classroom, or teacher level fetch class list if we don't already have it.
                    if (!_classroomList) {
                        classroomApi.getClassroomsForTeacher(params.teacherId, function (classroomList) {
                            _classroomList = classroomList;
                            exposeClassroomList(customerIsAdmin);
                        });
                    }
                } else {
                    // now that getList for teacher type returns students need to clear this to make sure
                    // we don't show wrong classrooms when switching between teachers
                    _classroomList = null;

                    // make sure we aren't showing the extra classroom list if current item is above
                    // classroom level
                    $scope.classroomList = null;
                }
            };

            /* updateBreadcrumbs
             * When the state changes successfully we update the breadcrumbs with the previous
             * state. Use this to also iterate through breadcrumbs and remove any stale breadcrumbs.
             */
            $scope.updateBreadcrumbs = function (type) {
                if(authentication.useBts2020Nav()){
                  return;
                }
                $scope.breadcrumbType = type;

                var breadcrumbOrder = navigation.getBreadcrumbOrder($state.params.breadcrumbs);
                $scope.breadcrumbs = _.map(breadcrumbOrder, function (type) {
                    return _.findWhere($scope.breadcrumbs, {
                        type: type
                    }) || {
                        type: type,
                        item: null
                    };
                });

                // filter out the types that the customer shouldn't see
                var invalidTypes = authentication.getCustomerInvalidTypes();
                $scope.breadcrumbs = _.filter($scope.breadcrumbs, function (breadcrumb) {
                    return !_.contains(invalidTypes, breadcrumb.type);
                });

                var params = $state.params;
                var breadcrumbSubject = $navigationApi.getBreadcrumbs($scope.breadcrumbs, params);

                // For admin customers need to grab the teacher breadcrumb item to add to the classroom
                // list if it's showing.
                var customer = authentication.getCustomer();
                var customerIsAdmin = authentication.isAdmin(customer);
                if (customerIsAdmin) {
                    breadcrumbSubject.subscribe(function (breadcrumbs) {
                        var teacherBreadcrumb = _.find($scope.breadcrumbs, {
                            type: 'teacher'
                        });

                        if (teacherBreadcrumb) {
                            _teacherItem = teacherBreadcrumb.item;
                            exposeClassroomList(customerIsAdmin);
                        } else {
                            _teacherItem = null;
                        }

                    });
                }
            };

            $scope.getItemList = function (toState, toParams, fromState, fromParams) {
                if ($scope.shouldUpdateBreadcrumbs(toState, toParams, fromState, fromParams)) {
                    // update breadcrumbs via navaigation-pane watch
                    $scope.updateBreadcrumbs(toState.name);
                }

                if (!$scope.list || (toState.name !== fromState.name)) {
                    $scope.getCurrentItemList();
                }
            };

            $scope.refreshItems = function () {
                // clear the http cache
                var $httpDefaultCache = $cacheFactory.get('$http');
                $httpDefaultCache.removeAll();

                // retrieve the current item (used in the left pane)
                $scope.getItem();
                // retrieve all items in the navigation list
                $scope.getCurrentItemList();
                // update breadcrumbs via navaigation-pane watch
                $scope.updateBreadcrumbs($state.current.name);
            };

            $scope.shouldUpdateBreadcrumbs = function (toState, toParams, fromState, fromParams) {
                //Only update breadcrumbs if:
                // - state name has changed
                // - in student state and switching student
                // - in classroom state and switching classroom
                var isSameState = toState.name === fromState.name;
                var hasStudentIds = !_.isUndefined(toParams.studentId) && !_.isUndefined(fromParams.studentId);
                var sameStudent = toParams.studentId === fromParams.studentId;
                var hasClassroomIds = !_.isUndefined(toParams.classroomId) && !_.isUndefined(fromParams.classroomId);
                var sameClassroom = toParams.classroomId === fromParams.classroomId;
                return !isSameState || (hasStudentIds && !sameStudent) || (hasClassroomIds && !sameClassroom);
            };

            authentication.getCustomerSubject().subscribe(function (customer) {
                if (customer.isDistrictAdmin()) {
                    $scope.infoHeader = customer.district_name;
                } else if (customer.isSchoolAdmin()) {
                    $scope.infoHeader = customer.school_name;
                } else if (customer.isTeacher()) {
                    if (customer.classroom_ids.length > 1) {
                        $scope.infoHeader = buildTeacherClassroomsName(customer.name);
                    } else {
                        // here we just start with the classroom breadcrumb
                        $scope.infoHeader = undefined;
                    }
                } else {
                    $scope.infoHeader = customer.name;
                }

                // Determine whether to show preview banner
                $scope.showPreviewBanner = edxPreviewBannerService.isBannerEnabledForCustomer(customer);
            });

            $rootScope.$on('$stateChangeError', function (e, toState, toParams, fromState, fromParams, error) {
                console.error('ROUTING ERROR: %s', error.code);
                $rootScope.$broadcast('logOutPressed');
            });

            $rootScope.$on('$stateChangeSuccess', function (e, toState, toParams, fromState, fromParams) {
                // Prevent left nav from animating when navigating to different pages.
                $scope.initialNavPane = $scope.showNavPane;

                if (toState.parent === 'report') {
                    if ($rootScope.mobile || $state.current.name === 'guardian') {
                        $scope.showNavPane = false;
                        $scope.initialNavPane = false;
                    }

                    // If we are loading the page for the first time (item is undefined) OR
                    // If we have changed state levels [district, grade, classroom, teacher, etc]
                    //    OR student changed update navigation OR classroom changed update navigation
                    // Item and navigation item list - otherwise we don't need to reload.
                    if ($scope.item === null || $scope.item === undefined || toParams.breadcrumbs !== fromParams.breadcrumbs ||
                        toParams.studentId !== fromParams.studentId || toParams.classroomId !== fromParams.classroomId) {
                        timeframe.setYearListSubject(new Rx.Subject(1));
                        $scope.getItem();
                        $scope.getItemList(toState, toParams, fromState, fromParams);
                    } else {
                        $timeout(function () {
                            // This is needed at least to notify navigation tabs to update when we enter edit mode.
                            // Can potentially remove when we move entirely to the new "Manage" area.
                            edxReportItemService.setItem($scope.item);

                            // deprecated: use edxReportItemService instead of itemReady event
                            $scope.$broadcast('itemReady', $scope.item);
                        });
                    }
                    $(perfectScrollbarSelector).each(function (index, item) {
                        if ($(item).hasClass("scroll-bar--navigation")) {
                            return;
                        }

                        item.scrollTop = 0;
                    });
                    // With the way the DOM was changed to accommodate the full width top nav, scrolling the window
                    // to get right pane contents to the top no longer works - IN-2835 MPO
                    angular.element(".main-content").scrollTop(0);

                    checkEarlierYearSelected();
                }
            });

            var trackSessionEvent = function (action, value) {
                dblAnalytics.eventTrack(action, {
                    category: 'Session',
                    value: value
                });
            };

        }
    ]);
